<template>
  <div>
    <a-page-header style="width: 105%;margin-left: -20px" title="">
      <template slot="tags">
        <a-breadcrumb>
          <a-breadcrumb-item href="">
            <a-icon type="rocket" />
            <span>{{ $t('message.txtManagement.title1') }}</span>
          </a-breadcrumb-item>
          <a-breadcrumb-item href="">
            <a-icon type="book" />
            <span>{{ $t('message.txtManagement.title2') }}</span>
          </a-breadcrumb-item>
        </a-breadcrumb>
      </template>
    </a-page-header>
    <div class="page-title" style="margin-bottom: 20px;">{{ $t('message.txtManagement.title2') }}</div>
    <a-card class="mb16">

      <div style="display: flex;justify-content: space-between">
        <a-form-model layout="inline" :model="searchForm">
          <a-form-model-item :label="$t('message.txtManagement.tableTitle2')">
            <a-input :size="$globalSize" :placeholder="$t('message.txtManagement.tableTitle2')"
              v-model="searchForm.contentName" />
          </a-form-model-item>
          <!-- <a-form-model-item label="渠道">
            <a-select :size="$globalSize" v-model="searchForm.channelId" palceholder="请选择渠道" style="width: 200px" :options="contentChannel.constant" allow-clear>
            </a-select>
          </a-form-model-item> -->
          
        </a-form-model>
        <a-button :size="$globalSize" class="my-btn" type="primary" :disabled="tableLoading" @click="getContentList">{{
              $t('message.commonUsage.search')
              }}</a-button>
      </div>

    </a-card>
    <div class="flex justify-content-end">
      <a-button slot="tabBarExtraContent" class="my-btn" :size="$globalSize" type="primary" icon="plus-circle" @click="newContent"
          :disabled="$store.getters.hasPermission($store.state.LIMIT_CONSTANTS.CONTENT_LIMIT)"
          >
            {{ $t('message.txtManagement.createPush') }}
          </a-button>
    </div>
    <div class="table mt16">
      <a-card>
        <a-tabs v-model="searchForm.channelId" @change="getContentList" :animated="false">
          <a-tab-pane v-for="(item) in contentChannel.constant" :key="item.value" :tab="item.label"></a-tab-pane>
          
        </a-tabs>
        <a-table class="components-table-demo-nested" :columns="tableColumns" style="margin-top: 35px" rowKey="id"
          :data-source="tables" :pagination="false" :loading="tableLoading" :scroll="{ x: 1500 }"
          :customHeaderCell="{ backgroundColor: '#fbbe00' }">
          <template slot="content" slot-scope="text, record, index">
            <my-button type="primary" style="width: 96px;" @click="showInfoDialog(text, record, index)">{{
              $t('message.commonUsage.preview') }}
              >
            </my-button>
          </template>
          <template slot="created_at" slot-scope="text, record">
            <span>{{ convertToDefaultTimezone(showTime(record.created_at)) }}</span>
          </template>

          <template slot="action" slot-scope="text, record">
            <my-button type="primary" shape="circle" class="edit-btn-icon" style="margin-right: 10px;"
              @click="upContentChange(record)" />
            <a-button type="primary" class="delete-btn-icon" shape="circle" @click="deleteContent(text, record)" />
          </template>
        </a-table>
        <my-pagination ref="maPaginationRef" @change="getContentList" :total="totalCount"></my-pagination>
      </a-card>
    </div>

    <preview-box v-if="previewVisible" @cancel="previewVisible = false" :previewItem="previewItem"></preview-box>
    <a-modal :visible="showReason" title="审核详情" centered :width="800" @ok="showReason = false" :closeIcon="null"
      :maskClosable="true" @cancel="showReason = false" class="reason_box">
      <a-table :columns="auditDetailCol" :data-source="auditDetailData">
        <template slot="refuse_reason" slot-scope="text">
          {{ (!text || text === 'null') ? '-' : text }}
        </template>
        <template slot="review_status" slot-scope="text">
          <a-tag color="green" v-if="text === 1">
            <a-icon type="check-circle" />
            成功
          </a-tag>
          <a-tag color="red" v-else>
            <a-icon type="close-circle" />
            失败
          </a-tag>
        </template>
        <template slot="cover_url" slot-scope="text,record">
          <div style="display:flex;justify-content: space-around;align-items: center">
            <div style="width: 20px;height: 20px;display:flex;justify-content: space-around;align-items: center">
              <img :src="text" alt="" style="max-width: 100%;max-height: 100%;">
            </div>
            <div>{{ record.sms_name }}</div>
          </div>
        </template>
      </a-table>
    </a-modal>
    <!-- 文案标签 -->
    <a-modal :visible="copyLabelVisible" :title="$t('message.txtManagement.lableTitle')" :width="1180" :footer="null"
      :maskClosable="false" @cancel="copyLabelVisible = false" :destroyOnClose="true">
      <copy-label />
    </a-modal>
    <!--    编辑-->
    <a-modal :visible="editVisible" :title="$t('message.txtManagement.AddFormTitle17')" :width="800"
      @cancel="cancelEdit" @ok="updateTmp" :confirmLoading="confirmLoading">
      <sms-and-app-push-temp :channel="currentChannel" ref="smsAndAppPushTempRef"
        v-if="currentChannel === 'SMS'"></sms-and-app-push-temp>
      <wechatoa-push-temp ref="wechatOAPushTempRef" v-if="currentChannel === 'WechatOA'"></wechatoa-push-temp>
      <email-push-temp ref="emailPushTempRef" v-if="currentChannel === 'Email'"></email-push-temp>
      <enterprise-wechat-push-temp ref="enterpriseWechatPushTempRef"
        v-if="currentChannel === '企业微信'"></enterprise-wechat-push-temp>
    </a-modal>

    <!--    审核-->
    <a-modal :visible="auditVisible" title="文案审核" @cancel="auditVisible = false" @ok="auditTmp">
      <a-form-model :model="auditForm" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="文案选择">
          <a-select :size="$globalSize" mode="multiple" placeholder="请选择" v-model="auditForm.ids" allowClear
            :maxTagCount="5">
            <a-select-option v-for="i in textList" :key="i.id">
              {{ i.content_name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="供应商选择">
          <a-select :size="$globalSize" mode="multiple" placeholder="请选择" v-model="auditForm.sms_ids" allowClear
            :maxTagCount="5">
            <a-select-option v-for="i in supplierList" :key="i.sms_id">
              {{ i.sms_name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

      </a-form-model>
    </a-modal>
    <create-push ref="createPushRef" @refresh="getContentList"></create-push>
  </div>

</template>

<script>
import copyLabel from './components/copyLabel.vue'
import textLibrarySelectModal from "@/views/material/components/textLibrarySelectModal";
import contentListService from "@/interface/pages/TxtManagement/contentListService";
import MyPagination from "@/components/MyPagination";
import MyButton from "@/components/MyButton/index";
import ContentLabel from "@/interface/pages/TxtManagement/contentLabel";
import createPush from "@/views/material/components/createPush";
import SmsAndAppPushTemp from "@/views/material/components/SmsAndAppPushTemp";
import WechatoaPushTemp from "@/views/material/components/WechatoaPushTemp";
import EmailPushTemp from "@/views/material/components/EmailPushTemp";
import previewBox from "@/views/material/components/previewBox";
import utils from "@/utils.js";
import EnterpriseWechatPushTemp from "@/views/material/components/EnterpriseWechatPushTemp";
import moment from "moment";
import { showTime } from '../../utils/common';
import { contentChannel } from '../../utils/constant';

export default {
  name: 'textManagement',
  props: {},
  components: {
    copyLabel,
    textLibrarySelectModal,
    MyPagination,
    MyButton,
    createPush,
    SmsAndAppPushTemp,
    WechatoaPushTemp,
    EnterpriseWechatPushTemp,
    previewBox,
    EmailPushTemp
  },
  data() {
    return {
      labelCol: {
        span: localStorage.getItem('i18n').startsWith('zh') ? 6 : 7
      },
      wrapperCol: {
        span: localStorage.getItem('i18n').startsWith('zh') ? 18 : 17
      },
      tableLoading: false,
      search_value: '',
      searchForm: {
        contentName: undefined,
        channelId: contentChannel.getValueByLabel('SMS'),
      },
      auditForm: {},
      supplierList: [],
      textList: [],
      copyLabelVisible: false,
      showReason: false,
      previewVisible: false,
      editVisible: false,
      auditVisible: false,
      currentChannel: '',
      auditDetailCol: [
        {
          dataIndex: "cover_url",
          key: "cover_url",
          title: '供应商',
          align: "center",
          width: 100,
          scopedSlots: { customRender: "cover_url" }
        },
        {
          dataIndex: "sign_name",
          key: "sign_name",
          title: '签名',
          align: "center",
        },
        {
          dataIndex: "review_status",
          key: "review_status",
          title: '状态',
          align: "center",
          scopedSlots: { customRender: "review_status" }
        },
        {
          dataIndex: "refuse_reason",
          key: "refuse_reason",
          title: '原因',
          align: "center",
          scopedSlots: { customRender: "refuse_reason" }

        },
        {
          dataIndex: "update_time",
          key: "update_time",
          title: '状态更新时间',
          align: "center"
        },
      ],
      auditDetailData: [],
      tables: [],
      totalCount: 0,
      tableColumns: [
        {
          dataIndex: "content_id",
          key: "content_id",
          title: () => this.$t('message.txtManagement.tableTitle1'),
          align: "center"
        },
        {
          dataIndex: "content_name",
          key: "content_name",
          title: () => this.$t('message.txtManagement.tableTitle2'),
          align: 'center',
          width: 350
        },
        {
          dataIndex: "content_detail",
          key: "content_detail",
          title: () => this.$t('message.txtManagement.tableTitle4'),
          align: 'center',
          scopedSlots: { customRender: "content" }
        },
        {
          dataIndex: "created_user_name",
          key: "created_user_name",
          title: () => this.$t('message.txtManagement.tableTitle5'),
          align: 'center',
        },
        {
          dataIndex: "created_at",
          key: "created_at",
          title: () => this.$t('message.txtManagement.tableTitle6'),
          align: 'center',
          scopedSlots: { customRender: "created_at" }
        },

        {
          dataIndex: "action",
          key: "action",
          title: () => this.$t('message.txtManagement.tableTitle7'),
          align: 'center',
          width: 150,
          fixed: 'right',
          scopedSlots: { customRender: "action" }
        }
      ],
      currentItem: null,
      previewItem: {},
      contentChannel,
      confirmLoading: false,
    }
  },
  mounted() {
    utils.languageChange(this, { labelCol: 8, wrapperCol: 16 }, { labelCol: 6, wrapperCol: 16 })
  },
  provide() {
    return {
      parent: this,
    }
  },
  methods: {
    showTime,
    onSearch() {
    },

    cancelEdit() {
      this.resetForm()
      this.editVisible = false
    },
    resetForm() {
      this.$refs.smsAndAppPushTempRef && this.$refs.smsAndAppPushTempRef.$refs.ruleForm.resetFields()
      this.$refs.wechatOAPushTempRef && this.$refs.wechatOAPushTempRef.$refs.ruleForm.resetFields()
      this.currentItem = null
      this.currentChannel = null
    },
    newContent() {
      // this.content_tag_ids = []
      this.$refs.createPushRef.showModal()
    },
    async showInfoDialog(text, record, index) {
      const { data: res } = await contentListService.getContentById(this, { params: { contentId: record.content_id, channelId: this.searchForm.channelId } })
      if (res.code === '200') {
        const arr = []

        if (res.data.channel_id === '企业微信') {
          res.data.attachments.forEach((i, index) => {
            arr.push({ ...i, showDelete: false, id: moment().valueOf() + index })
          })
        }
        this.previewItem = {
          type: this.contentChannel.getLabelByValue(this.searchForm.channelId),
          // type:'SMS',
          detail: res.data.content,
          app_push_title: record.app_push_title,
          attachments: [...arr],
        }
        this.previewVisible = true
      } else {
        this.$message.error(res.message)
      }
    },
    showFailure(record) {
      this.failureReason = record.refuse_reason
      this.auditDetailData = record.review_detail
      this.showReason = true
    },
    async upContentChange(record) {
      const { data: res } = await contentListService.getContentById(this, { params: { contentId: record.content_id, channelId: this.searchForm.channelId } })
      if (res.code === '200') {
        this.currentItem = res.data
        this.currentChannel = this.contentChannel.getLabelByValue(this.searchForm.channelId)
        // this.currentChannel = 'SMS'
        this.editVisible = true
      } else {
        this.$message.error(res.message)
      }

    },
    async auditTmp() {
      const data = {
        ...this.auditForm,
        ids: this.auditForm.ids.map(String)
      }
      const { data: res } = await contentListService.submitReviews(this, { data })
      try {
        if (res.code === '200') {
          this.$message.success('已提交审核')
          this.getContentList()
          this.auditVisible = false
        } else {
          this.$message.error(res.message)
        }
      } catch (e) {
        console.log(e)
      }
    },
    async updateTmp() {
      this.confirmLoading = true
      let ref
      let content_channel_id = this.searchForm.channelId
      switch (this.currentChannel) {
        case 'SMS':
          ref = this.$refs.smsAndAppPushTempRef
          break;
        case 'Email':
          ref = this.$refs.emailPushTempRef
          break;
        default:
          ref = this.$refs.smsAndAppPushTempRef
          break;
      }
      let formData = {};
      try {
        formData = await ref.formValidate();
        if (!formData) {
          this.confirmLoading = false;
          return;
        }
        // ...
      } catch (error) {
        console.error('表单验证出错:', error);
        this.confirmLoading = false;
        return;
      }
      let data = {
        contentId: this.currentItem.content_id,
        loginId: localStorage.getItem('userId'),
        contentName: formData.content_name,
        content: formData.content,
        channelId: content_channel_id,
        subject: formData.subject
      }
      let func = contentListService.updateContent
      //attachment为空 则传null
      if (!data.attachments) {
        data.attachments = null;
      }
      // SMS
      if (content_channel_id === contentChannel.getValueByLabel('SMS')) {
        data = {
          ...data,
          link: formData.link,
        }
      }
      if (content_channel_id === contentChannel.getValueByLabel('Email')) {
        data = {
          ...data,
          templateId: formData.template_id,
          contentValue: formData.contentValue,
        }
        func = contentListService.updEmailContent
      }
      const { data: res } = await func(this, { data })
      try {
        if (res.code === '200') {
          this.$message.success(res.message)
          this.getContentList()
          this.resetForm()
          this.editVisible = false
        } else {
          this.$message.error(res.message)
        }
        this.confirmLoading = false
      } catch (e) {
        console.log(e)
        this.confirmLoading = false

      }
    },
    deleteContent(text, record) {
      var id = record.content_id;
      var that = this;
      this.$confirm({
        title: this.$t('message.txtManagement.txtMgtMsg1'),
        content: this.$t('message.txtManagement.txtMgtMsg2'),
        okText: this.$t('message.txtManagement.lableTitle4'),
        okType: "primary",
        cancelText: this.$t('message.userManagement.addUserTitle1'),
        onOk() {
          return new Promise((resolve, reject) => {
            let body = {
              contentId: id,
              loginId: localStorage.getItem('userId'),
              channelId: that.searchForm.channelId
            };
            contentListService.delContent(that, { data: body })
              .then((response) => {
                let res = response.data;
                if (res.code == "200") {
                  that.$store.dispatch('fetchButtonPermission')
                  that.getContentList();
                  resolve();
                  that.$message.success(that.$t('message.txtManagement.txtMgtMsg3'));
                } else {
                  that.$message.error(res.message);
                  reject();
                }
              })
              .catch((error) => {
                console.log(error, "删除失败！");
              }).finally(() => {
              });
          })

        },
        onCancel() {
          that.$message.warning(that.$t('message.txtManagement.txtMgtMsg4'));
        }
      });


    },
    syncText() {
    },
    async getContentList() {
      this.tableLoading = true
      const params = {
        ...this.searchForm,
        ...this.$refs.maPaginationRef.pagination
      }
      const { data: res } = await contentListService.getContentList(this, { params })
      try {
        if (res.code === '200') {
          this.tables = res.data
          this.totalCount = res.totalCount
        } else {
          if (res.code !== '400') {
            this.$message.error(res.message)
          }
        }
      } catch (e) {
        console.log(e)
      }
      this.tableLoading = false
    },
    getAllContentList() {
      this.textList = [];
      let name = { channel: 2 };
      contentListService
        .getAllContentList(this, { params: name })
        .then(
          function (response) {
            var res = response.data;
            if (res.code == "200") {
              this.textList = res.data;
            } else {
              this.$message.error(res.message);
            }
          }.bind(this)
        )
        .catch((reponse) => {
          console.log(reponse);
        });
    },
    async showAuditModal() {
      await this.getAllContentList()
      this.auditVisible = true
    }
  },
  watch: {},
  computed: {}
}
</script>

<style scoped lang="less">
.statusBtn {
  background-color: #fff !important;
  width: 96px;
  height: 24px;
  line-height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.commit_img {
  width: 16px;
  height: 16px;
  margin-right: 4px;
}
</style>